let LOGIN_STATE_PART0=0;
let LOGIN_STATE_PART1=1;
let LOGIN_STATE_PART2=2;
let LOGIN_STATE_DONE=100;

let PAGE_STATE_MUSIC_LIST=0;
let PAGE_STATE_UPLOAD=1;

let NO_NEED_LOAD_MUSIC=0;

let DIALOG_MODE_TIPS=0;
let DIALOG_MODE_DEL=1;

export default {
  LOGIN_STATE_PART0,
  LOGIN_STATE_PART1,
  LOGIN_STATE_PART2,
  LOGIN_STATE_DONE,
  PAGE_STATE_MUSIC_LIST,
  PAGE_STATE_UPLOAD,
  NO_NEED_LOAD_MUSIC,
  DIALOG_MODE_TIPS,
  DIALOG_MODE_DEL
}



// WEBPACK FOOTER //
// ./src/util/global.js